{
  "title": "Amount to Send",
  "subtitle": "Check the recipient information before to confirm the transaction",
  "titlerecipient": "Recipient Information",
  "schedule": "I want to schedule this transaction and approve it later.",
  "input": {
    "availablebalance": "Source Account Balance",
    "transactionvalue": "Outstanding Amount",
    "finalbalance": "Final Balance",
    "fee": "Fee",
    "swiftfee": "Fee",
    "domesticwirefee": "Fee",
    "processingfee": "Fee",
    "holdername": "Holder Name",
    "accountnumber": "Account Number",
    "routingnumber": "Routing Number",
    "bankname": "Institution Name",
    "bankaddress": "Bank Address",
    "bankcountry": "Institution Country",
    "iban": "IBAN",
    "swiftbic": "SWIFT BIC",
    "purpose": "Transaction Purpose",
    "description": "Description",
    "memo": "MEMO",
    "walletaddress": "Wallet Address",
    "assettypeid": "Asset Type"
  },
  "card": {
    "transactionsuccess": "Transaction Completed",
    "transactionsuccesssubtitle": "The amount was sent successfully",
    "transactionfailed": "Transaction Failed",
    "transactionfailedsubtitle": "The amount was not sent. Please try again later.",
    "transactiontimeout": "Transaction Timeout",
    "transactiontimeoutsubtitle": "We couldn't confirm the transaction status, but it may still be completed. Please check your bank statement to confirm the transaction.",
    "transactionscheduledsubtitle": "The transaction was scheduled successfully. You can approve it later."
  },
  "sendwithwallet": {
    "title": "Create a address and send with your wallet",
    "options": {
      "sendwithizzi": "Send with Izzi account",
      "sendwithwallet": "Send with External Wallet"
    },
    "input": {
      "paymentrail": "Select the blockchain",
      "currency": "Select the asset"
    },
    "error": "Error to approve the transaction in your wallet. Please try again later."
  }
}
